import { ca } from '@cian/analytics';
import { TBlockLabel } from '../../types/events';

export function clickBlock(label: TBlockLabel) {
  ca('event', {
    name: 'oldevent',
    category: 'OwnerHelper',
    action: 'click_block',
    label,
  });
}

export function clickFaq(label: string) {
  ca('event', {
    name: 'oldevent',
    category: 'OwnerHelper',
    action: 'click_faq',
    label,
  });
}

export function clickAskProfessional() {
  ca('event', {
    name: 'oldevent',
    category: 'OwnerHelper',
    action: 'click_ask_professional',
  });
}

export function clickQuestionsToRealtor() {
  ca('event', {
    name: 'oldevent',
    category: 'OwnerHelper',
    action: 'click_questions_to_realtor',
  });
}
